import styled from 'styled-components'

export const MainContainer = styled.div`
  display: grid;
  place-content: center;
  padding-top: 200px;
`
